import React, { useState } from "react";
import Navbar from "../../../component/Navbar";
import Footer from "../../../component/Footer";
import PopUp from "./PopUp";

function SelectContactMode() {
  const pickedTherapist = JSON.parse(localStorage.getItem("pickedTherapist"));
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [popUpStyles, setPopUpStyles] = useState({});

  const MusaPosition = {
    position: "absolute",
    left: "22rem",
    top: "11rem",
    zIndex: "20",
  };
  const WajudPosition = {
    position: "absolute",
    left: "22rem",
    top: "21rem",
    zIndex: "20",
  };
  const RahmatPosition = {
    position: "absolute",
    left: "22rem",
    top: "27rem",
    zIndex: "20",
  };

  function selectTherapist(classes) {
    if (isPopUpOpen == false) {
      setIsPopUpOpen(true);
    }
    setPopUpStyles(classes);
  }
  return (
    <div className="bg-[#D4DDCC] relative">
      <Navbar />
      <section className="flex mt-[30px] mb-[40px] text-[#2A5801] ml-[30px] h-[600px]">
        <div className="pt-[20px] pb-[20px] bg-[#DCAE96] w-fit rounded-[10px] mx-[25px] px-[20px]">
          <p className="text-lg font-semibold">Current Therapist</p>

          <div className="flex flex-col">
            <div
              className="flex bg-white rounded-[10px] p-[10px] mt-[10px] cursor-pointer"
              onClick={() => selectTherapist(MusaPosition)}
            >
              <img
                className="w-12 h-12 rounded-full"
                // src={pickedTherapist.image}
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrBp4rAadRiXmk6NWl3redkvGJgWGDkBT4vA&usqp=CAU"
                alt="musa"
              />
              <div>
                <div className="flex">
                  <h2 className="ml-[30px]">
                    {pickedTherapist.user.firstName}
                  </h2>
                  <img
                    className="ml-[42px] mt-[7px] w-[8px] h-[8px]"
                    src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701722601/Ellipse_40_aq2xym.png"
                    alt="green dot"
                  />
                </div>
                <br />
                <h3 className="ml-[10px] mt-[-20px] text-[14px]">
                  Senior At {pickedTherapist.specialization}
                </h3>
              </div>
            </div>

            {/* <p className="mt-12 font-semibold text-lg">Previous Therapists</p> */}
            {/* <div
              className="flex bg-white rounded-[10px] p-[10px] mt-[10px] cursor-pointer"
              onClick={() => selectTherapist(WajudPosition)}
            >
              <img
                className="w-12 h-12 rounded-full"
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1700513418/sue40dii2kkn1slpmlgb.jpg"
                alt="wajud"
              />
              <div>
                <div className="flex">
                  <h2 className="ml-[30px]">K. WAJUD</h2>
                  <img
                    className="ml-[42px] mt-[7px] w-[8px] h-[8px]"
                    src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701722600/Ellipse_yellow_cyolxx.png"
                    alt
                  />
                </div>
                <br />
                <h3 className="ml-[10px] mt-[-20px] text-[14px]">
                  Senior At Therapy
                </h3>
              </div>
            </div> */}

            {/* <div
              className="flex bg-white rounded-[10px] p-[10px] mt-[20px] cursor-pointer"
              onClick={() => selectTherapist(RahmatPosition)}
            >
              <img
                className="w-12 h-12 rounded-full"
                src="https://res.cloudinary.com/deofacwik/image/upload/v1694602402/ladyyy_i1q0qa.jpg"
                alt="rahmat"
              />
              <div>
                <div className="flex">
                  <h2 className="ml-[30px]">P. RAHMAH</h2>
                  <img
                    className="ml-[30px] mt-[7px] w-[8px] h-[8px]"
                    src="https://res.cloudinary.com/dxswouxj5/image/upload/v1701722601/Ellipse_42-1_im7af1.png"
                    alt="red dot"
                  />
                </div>
                <br />
                <h3 className="ml-[10px] -mt-4 text-[14px]">
                  Senior At Therapy
                </h3>
              </div>
            </div> */}
          </div>
        </div>
        {/* Get In Touch */}
        <div id="in-touch" className="bg-[#D4DDCC] w-3/5 rounded-[10px] py-32">
          <div className="flex justify-center items-center">
            <img src="https://res.cloudinary.com/druryt8ny/image/upload/v1700518851/rsnuvxsp8itnttc6hk9u.png" />
          </div>
          <div className="flex justify-center items-center mt-4 font-semibold">
            <h3 className="text-center">
              Get In Touch With Your Therapist Either By Chat, Voice Call Or
              Video Call
            </h3>
          </div>
        </div>

        {isPopUpOpen && (
          <div style={popUpStyles}>
            <PopUp />
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
}

export default SelectContactMode;
